import '../Sass/App.scss';
import React, { useState } from 'react';
import { Turn } from './Turn';

export function TurnControl(props) {

    const [infected, setInfected] = useState(20)
    const [x, setX] = useState(1)
    const [y, setY] = useState(5)
    const [z, setZ] = useState(1)

    function changeTurn(newValue) {
        props.setPlayerInFocus(newValue)
    }

    return (
        <>
        <div className="turn-control" style={{backgroundColor: 'black'}}>
            <div className='turn-label'>CURRENT_TURN</div>
            { props.players.map((player, index) => 
                ( <Turn codebaseId={player.codebaseId} playerInFocus={props.playerInFocus} changeTurn={changeTurn} nickname={player.nickname} icon={player.icon} /> )
            )}
            <div className='turn-label' style={{color: 'red'}}>%_INFECTED</div>
            <div className='turn-bar-dashboard' style={{borderColor: 'red', padding: 0}}>
                <button onClick={() => setInfected(infected-1)} className="dashboard-button">-</button>
                <span> {infected} </span>
                <button onClick={() => setInfected(infected+1)} className="dashboard-button">+</button>
            </div>
            <div className='turn-label'>SET_VARIABLES</div>
            <div className='turn-bar-dashboard' style={{padding: 0}}>
                <button onClick={() => setX(x-1)} className="dashboard-button">-</button>
                <span> x = {x} </span>
                <button onClick={() => setX(x+1)} className="dashboard-button">+</button>
            </div>
            <div className='turn-bar-dashboard' style={{padding: 0}}>
                <button onClick={() => setY(y-1)} className="dashboard-button">-</button>
                <span> y = {y} </span>
                <button onClick={() => setY(y+1)} className="dashboard-button">+</button>
            </div>
            <div className='turn-bar-dashboard' style={{padding: 0}}>
                <button onClick={() => setZ(z-1)} className="dashboard-button">-</button>
                <span> z = {z} </span>
                <button onClick={() => setZ(z+1)} className="dashboard-button">+</button>
            </div>
        </div>
        </>
    )
}